import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a347840e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "search-field"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["hidden"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "qr-scanner-canvas",
  hidden: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_home_welcome_layout = _resolveComponent("home-welcome-layout")!
  const _component_home_button_layout = _resolveComponent("home-button-layout")!
  const _component_home_map_layout = _resolveComponent("home-map-layout")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: false }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button),
                  (_ctx.insideSubmap)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        onClick: _ctx.exitSubmap,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            class: "exit-submap-icon",
                            src: "assets/icon/exit.svg"
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (!_ctx.isShowingConfiguredHomeScreenLayout)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 1,
                          onClick: _ctx.goHome,
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { src: "assets/icon/home.svg" })
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  (_ctx.showSearchField)
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 0,
                        onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)))
                      }, [
                        (_ctx.showSearchField)
                          ? (_openBlock(), _createElementBlock("input", _hoisted_1))
                          : _createCommentVNode("", true)
                      ], 32))
                    : (_ctx.isShowingConfiguredHomeScreenLayout)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Home "))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  (!_ctx.showSearchField)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        size: "small",
                        onClick: _ctx.toggleQrCodeScanner
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { src: "assets/icon/qr-code.svg" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.showSearchField)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 1,
                        size: "small",
                        onClick: _ctx.doSearch
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { src: "assets/icon/search.svg" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_ion_button, {
                        key: 2,
                        size: "small",
                        onClick: _ctx.toggleSearchField
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { src: "assets/icon/search.svg" })
                        ]),
                        _: 1
                      }, 8, ["onClick"])),
                  (_ctx.showSearchField)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 3,
                        onClick: _ctx.toggleSearchField,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { src: "assets/icon/close.svg" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        scrollY: "false"
      }, {
        default: _withCtx(() => [
          (_ctx.showWelcomeLayout)
            ? (_openBlock(), _createBlock(_component_home_welcome_layout, {
                key: 0,
                onMap: _ctx.handleHideWelcomeLayout,
                onPoint: _ctx.handleWelcomeLayoutShowPoint,
                onSubmap: _ctx.handleWelcomeLayoutShowSubmap
              }, null, 8, ["onMap", "onPoint", "onSubmap"]))
            : _createCommentVNode("", true),
          (_ctx.showButtonLayout)
            ? (_openBlock(), _createBlock(_component_home_button_layout, {
                key: 1,
                onHide: _ctx.handleHideButtonLayout
              }, null, 8, ["onHide"]))
            : _createCommentVNode("", true),
          _createVNode(_component_home_map_layout),
          _createVNode(_component_router_view),
          _createElementVNode("video", {
            id: "qr-scanner-video",
            playsinline: "",
            hidden: !_ctx.showQrScanner
          }, null, 8, _hoisted_3),
          _hoisted_4,
          _createElementVNode("input", {
            type: "file",
            id: "qr-scanner-file-input",
            hidden: "",
            accept: "image/*;capture=camera",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleQrFileInput && _ctx.handleQrFileInput(...args)))
          }, null, 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}